module.exports = __webpack_public_path__ + "images/xl_panda.jpg?0f521eec4bdbf94025e85fc3b6255668";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_panda.jpg
// module id = 245
// module chunks = 1